"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import Link from "next/link";
interface InventoryHoldNoticeModalProps {
  isOpen: boolean;
  onClose: () => void;
}
const InventoryHoldNoticeModal: React.FC<InventoryHoldNoticeModalProps> = t0 => {
  const $ = _c(14);
  const {
    isOpen,
    onClose
  } = t0;
  if (!isOpen) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h3 className="t-text-xl t-font-semibold t-text-gray-900">A Quick Note on Vehicle Availability</h3>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <svg className="t-w-5 t-h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" /></svg>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onClose) {
    t3 = <div className="t-flex t-justify-between t-items-start t-p-4 t-rounded-t">{t1}<button type="button" className="t-text-gray-400 t-bg-transparent t-hover:bg-gray-200 t-hover:text-gray-900 t-rounded-lg t-text-sm t-p-1.5 t-ml-auto t-inline-flex t-items-center" onClick={onClose} aria-label="Close modal">{t2}</button></div>;
    $[2] = onClose;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="t-text-base t-leading-relaxed t-text-gray-600">Please be aware that we ship nationwide and have a large team selling from the same inventory. What we have now may not be here later today. Items sell very quickly from our inventory!</p>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="t-p-6 t-space-y-4">{t4}<p className="t-text-base t-leading-relaxed t-text-gray-600">With a refundable $500 deposit plus the card processing fee (a $514.80 card total including 2.9% of the $500 deposit + $0.30) and a complete credit application, we can hold the vehicle you're interested in for 24 hours. Ask for details if you would like us to hold a vehicle for you. See <Link href="/faqs" className="t-underline">deposit terms in our FAQs</Link>.</p></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== onClose) {
    t6 = <div className="t-flex t-items-center t-justify-end t-p-6 t-space-x-2 t-border-t t-border-gray-200 t-rounded-b"><button onClick={onClose} type="button" className="t-text-white t-bg-automotive-primary t-hover:bg-automotive-secondary t-focus:ring-4 t-focus:outline-none t-focus:ring-blue-300 t-font-medium t-rounded-lg t-text-sm t-px-5 t-py-2.5 t-text-center">I Understand</button></div>;
    $[6] = onClose;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t3 || $[9] !== t6) {
    t7 = <div className="t-relative t-w-full t-max-w-md t-p-4 t-mx-auto t-bg-white t-rounded-lg t-shadow-elegant" onClick={_temp}>{t3}{t5}{t6}</div>;
    $[8] = t3;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== onClose || $[12] !== t7) {
    t8 = <div className="t-fixed t-inset-0 t-z-50 t-flex t-items-center t-justify-center t-bg-black t-bg-opacity-50 t-backdrop-blur-sm" onClick={onClose}>{t7}</div>;
    $[11] = onClose;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
};
export default InventoryHoldNoticeModal;
function _temp(e) {
  return e.stopPropagation();
}